let language = {
    MODIFY_EMAIL_SECURITY_TEXT: "Email Security",
    MODIFY_EMAIL_TITLE_TEXT: "Modify Email Account",
    MODIFY_EMAIL_LABLE_TEXT: "Enter your email, and we'll send you a email confirm link. This may take a few minutes!",
    MODIFY_EMAIL_REQUIRED_TEXT: "can't be empty!",
    MODIFY_EMAIL_PATTERN_TEXT: "The email format is incorrect",
    MODIFY_EMAIL_PLACEHOLDER_TEXT: "Please enter a valid email address",

    MODIFY_EMAIL_CANCEL_TEXT: "cancel",
    MODIFY_EMAIL_CONFIRM_TEXT: "confirm",
    
};

export { language }